import { Language, Country } from '@/interfaces/Countries'

const languages: Language[] = [
  {
    code: 'fr',
    title: 'Français'
  },
  {
    code: 'en',
    title: 'English'
  },
  {
    code: 'es',
    title: 'Español'
  },
  {
    code: 'de',
    title: 'Deutsch'
  },
  {
    code: 'nl',
    title: 'Nederlands'
  },
  {
    code: 'pt',
    title: 'Português'
  },
  {
    code: 'it',
    title: 'Italiano'
  },
  {
    code: 'pl',
    title: 'Polska'
  }
]

export const availableLanguages: string[] = process.env.VUE_APP_ACTIVE_LANGUAGES.split(',')

export const availableCountries: Country[] = availableLanguages.map((language) => {
  return {
    language,
    icon: `flag-${language}`,
    data: languages.find((el) => el.code === language)
  }
})

export const getAvailableCountryDataByCode = (code): Country => {
  return availableCountries.find((el) => el.data.code === code)
}
